import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { PreferencesContext } from './preferencesContext'
import { ACCENT_OPTIONS, LANGUAGE_OPTIONS, loadPreferences, savePreferences } from './preferencesConstants'

export function PreferencesProvider({ children }) {
  const [prefs, setPrefs] = useState(loadPreferences)

  useEffect(() => {
    document.documentElement.dataset.accent = prefs.accent
    document.documentElement.lang = prefs.language
  }, [prefs.accent, prefs.language])

  useEffect(() => {
    savePreferences(prefs)
  }, [prefs])

  const setLanguage = useCallback((lang) => {
    setPrefs((p) => ({ ...p, language: LANGUAGE_OPTIONS.includes(lang) ? lang : 'de' }))
  }, [])

  const setAccent = useCallback((accent) => {
    setPrefs((p) => ({ ...p, accent: ACCENT_OPTIONS.includes(accent) ? accent : 'violet' }))
  }, [])

  const setCompactList = useCallback((v) => {
    setPrefs((p) => ({ ...p, compactList: Boolean(v) }))
  }, [])

  const setDateFormat = useCallback((format) => {
    setPrefs((p) => ({ ...p, dateFormat: ['short', 'medium', 'long'].includes(format) ? format : 'medium' }))
  }, [])

  const value = useMemo(
    () => ({
      ...prefs,
      setLanguage,
      setAccent,
      setCompactList,
      setDateFormat,
    }),
    [prefs, setLanguage, setAccent, setCompactList, setDateFormat]
  )

  return (
    <PreferencesContext.Provider value={value}>
      {children}
    </PreferencesContext.Provider>
  )
}
